import { Link as RouterLink } from 'react-router-dom'
import { styled, Theme } from '@mui/material'

export const Link = styled(RouterLink)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
`
